import { NumberRangeBaseMiddlewareUtils } from '../shared/numberRangeBaseMiddlewareUtils';

import type { IFilterMiddlewareUtils } from '../shared/types';
import type { INumberRangeFilterValue } from './types';

/**
 * 数值范围筛选器中间件工具
 * 复用 NumberRangeBaseMiddlewareUtils 基类逻辑
 */
class NumberRangeFilterMiddlewareUtils
  extends NumberRangeBaseMiddlewareUtils
  implements IFilterMiddlewareUtils<INumberRangeFilterValue, IRecord<number>> {}

export default NumberRangeFilterMiddlewareUtils;
